import React from "react";
import PropTypes from "prop-types";

import ctl from "@netlify/classnames-template-literals";

import Loader from "svgs/loader.svg";
import ButtonArrow from "svgs/button-arrow.svg";
import { PLink, Text } from "components";

const Button = ({
  text,
  variant: buttonVariant,
  size: buttonSize,
  isLoading,
  onClick,
  disabled: buttonDisabled,
  href,
  to,
  children,
  hasArrow,
  addClass,
}) => {
  const buttonStyle = ctl(`
  ${baseStyle}
  ${sizes[buttonSize]}
  min-w-[100%]
  ${variants[buttonVariant]}
  ${buttonDisabled && `opacity-25`}
  `);

  let ButtonElement = "button";
  let linkProps = {};

  if (href || to) {
    ButtonElement = PLink;
    if (to) {
      linkProps.to = to;
    }

    if (href) {
      linkProps.href = href;
    }
  }

  return (
    <ButtonElement
      className={`${buttonStyle} ${addClass}`}
      onClick={onClick}
      disabled={buttonDisabled || isLoading}
      addClass
      {...linkProps}
    >
      <Text variant="p14" as="span" weight="600">
        {" "}
        {text || children}
      </Text>

      {isLoading && <Loader />}
      {hasArrow && !isLoading && (
        <ButtonArrow
          className={`ml-2 ${
            buttonVariant === "secondary-light"
              ? "fill-secondary-100"
              : "fill-secondary"
          }`}
        />
      )}
    </ButtonElement>
  );
};

const baseStyle = ctl(`
rounded-full
text-primary
text-center
font-semibold
transition
duration-400
inline-flex
items-center
justify-center
disabled:cursor-not-allowed
h-[54px]

`);

const sizes = {
  xsmall: `
  min-w-[98px]
  `,

  small: `
  md:min-w-[200px]
  min-w-[160px]
  `,
  medium: `
  min-w-[275px]

  `,
  large: `
  min-w-[325px]

  `,
  xlarge: `
  min-w-[325px]
  `,
};

const variants = {
  primary: `
bg-primary
text-secondary
hover:bg-primary-300
disabled:bg-primary-200
disabled:text-secondary-600
`,
  "secondary-dark": `
bg-secondary-100
text-secondary
border
border-secondary
`,
  "secondary-light": `
bg-transparent
text-secondary-100
border
border-secondary-100
`,
  alternative: `
bg-secondary-300
text-secondary
hover:bg-secondary-400
disabled:bg-secondary-200
disabled:text-primary-600
`,
};

Button.defaultProps = {
  variant: "primary",
  size: "small",
};
Button.propTypes = {
  text: PropTypes.string,
  variant: PropTypes.oneOf([
    "primary",
    "secondary-dark",
    "secondary-light",
    "alternative",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large", "xlarge"]),
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  to: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  addClass: PropTypes.string,
};

export { Button };
